const routes = [{
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [{
      path: '',
      component: () => import('pages/Index.vue')
    }]
  },
  {
    path: '/index.html',
    component: () => import('layouts/MainLayout.vue'),
    children: [{
      path: '',
      component: () => import('pages/Index.vue')
    }]
  },
  // {
  //   path: '/user',
  //   component: () => import('layouts/MainLayout.vue'),
  //   children: [{
  //     path: '/user',
  //     component: () => import('pages/Index.vue')
  //   }]
  // },
  {
    path: '/show',
    // component: () => import('layouts/MainLayout.vue'),
    component: () => import('pages/Show.vue')
  },
  {
    path: '/question',
    // component: () => import('layouts/MainLayout.vue'),
    component: () => import('pages/Question.vue')
  },
  {
    path: '*',
    component: () => import('layouts/MainLayout.vue'),
    children: [{
      path: '',
      component: () => import('pages/Index.vue')
    }]
  }
]



export default routes
